import API, { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { onRegisterCompleted } from './graphql/subscriptions';
import { isPassportProfile, getRuntimeConfig } from '../../app-config';

if (isPassportProfile()) {
  try {
    const { aws_appsync_graphqlEndpoint, aws_region: aws_appsync_region } = getRuntimeConfig();

    API.configure({
      aws_appsync_graphqlEndpoint,
      aws_appsync_region,
      aws_appsync_authenticationType: GRAPHQL_AUTH_MODE.AWS_LAMBDA
    });

  } catch (e) {
    throw new Error(e);
  }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function registerCompleteSubscription(registrationId: string, authToken: string): ReturnType<typeof API.graphql> {
  return API.graphql({
    authToken,
    variables: { registrationId },
    query: onRegisterCompleted,
    authMode: GRAPHQL_AUTH_MODE.AWS_LAMBDA
  });
}

